import {
  Button,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import "../../../assets/css/steps.css";
import PreviewDelegation from "../../Generics/PreviewDelegation";

const Step_2_Delegation = ({
  previewDocumentDelegation,
  privacyAccepted,
  setPrivacyAccepted,
}) => {
  return (
    <Grid container>
      <Grid item xs={12} className="container-steps">
        <Typography className="title-steps">
          Verifica il testo della delega
        </Typography>
        <Grid item xs={12} md={8}>
          <Typography className="text-steps" sx={{ mt: 1 }}>
            Se il testo è corretto,{" "}
            <span style={{ fontWeight: "bold" }}>prosegui per confermarlo</span>
            . Se invece vuoi rivedere una o più scelte, torna indietro per
            effettuare le modifiche.
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          md={12}
          className="marginTop-input"
          sx={{
            marginTop: { xs: "30px !important", md: "30px !important" },
            display: "flex",
            justifyContent: "center",
          }}
        >
          <PreviewDelegation
            fileUrl={previewDocumentDelegation}
            privacyAccepted={privacyAccepted}
            setPrivacyAccepted={setPrivacyAccepted}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Step_2_Delegation;
